import styled, { css } from "styled-components";
import { fontCondensedNormal } from "../../_static/Typography";

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  height: ${({ isShortened }) => (isShortened ? "4px" : "20px")};
  margin-top: ${({ marginTop }) => (marginTop > 0 ? `${marginTop}px` : "0")};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom > 0 ? `${marginBottom}px` : "0"};
`;

export const InnerWrapper = styled.div`
  position: relative;
  display: flex;
  width: ${({ isWidth }) => isWidth}px;
  height: 100%;
  margin-right: ${({ marginRight }) =>
    marginRight > 0 ? `${marginRight}px` : "0"};
`;

export const InnerContainer = styled.span`
  width: ${({ isWidth }) => isWidth}px;
  height: ${({ isShortened }) => (isShortened ? "4px" : "20px")};
  background-color: ${({ backgroundColor }) => backgroundColor};
  opacity: ${({ isOpacity }) => isOpacity};
  transform: skew(-25deg);
`;

export const InnerText = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  color: ${({ color }) => color};
  font-family: ${fontCondensedNormal};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-transform: uppercase;
  ${({ isShortened }) =>
    isShortened
      ? css`
          display: none;
        `
      : ""}
`;
